import { SET_SELECTED_SIDE_MENU } from "../types/sideMenuDropdownTypes.js";

export const setSelectedSideMenu = (value) => {
  return {
    type: SET_SELECTED_SIDE_MENU,
    payload: { data: value },
  };
};
